(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MetaTagSearch', MetaTagSearch);

    MetaTagSearch.$inject = ['$resource', 'ENV'];

    function MetaTagSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/meta-tags/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
